import type { SportUiConfiguration } from "../../types/sportUiConfiguration.ts";
import { defaultsUiConfig } from "./defaultsUi.ts";

export const hockeyUiConfig: SportUiConfiguration = {
  ...defaultsUiConfig,
  uniforms: {
    showEntityManageUniforms: false,
    allowFixtureUniformChange: false,
  },
};
